import type { ModuleKey, WidgetDef } from "./types";

const registry = new Map<string, WidgetDef>();

export function registerWidget(def: WidgetDef): void {
  registry.set(def.id, def);
}

export function getWidget(id: string): WidgetDef | undefined {
  return registry.get(id);
}

export function getModuleWidgets(mod: ModuleKey): WidgetDef[] {
  return Array.from(registry.values()).filter((w) => w.module === mod);
}

/** Test-only — clears the singleton between tests. Not exported from any index. */
export function __resetRegistryForTests(): void {
  registry.clear();
}
